import {webClient} from "../../config/axios";
import {handleError} from "../handleRequestError";

export const daysOverWhoRequest = (stationId,callback) => {
    let url = `/station-data/${stationId}/days-over-who`
    webClient.get(url)
        .then(response => {
            callback(response.data, false);
        })
        .catch(err => {
            handleError(err, callback);
        });
};